/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'

export const CreateFormSubmissionDocument = `
    mutation createFormSubmission($input: CreateFormSubmissionInput!) {
  createFormSubmission(input: $input) {
    submissionId
    success
    message
    metaData {
      pendingVerificationOrdinalities
    }
  }
}
    `
export const UpdateFormSubmissionDocument = `
    mutation updateFormSubmission($input: UpdateFormSubmissionInput!) {
  updateFormSubmission(input: $input) {
    submissionId
    success
    message
    metaData {
      pendingVerificationOrdinalities
    }
  }
}
    `
export const CompleteFormSubmissionDocument = `
    mutation completeFormSubmission($input: CompleteFormSubmissionInput!) {
  completeFormSubmission(input: $input) {
    submissionId
    success
    message
  }
}
    `
export const CreateConsentPacketExternalDocument = `
    mutation createConsentPacketExternal($content: CreateConsentPacketExternalInput!) {
  createConsentPacketExternal(content: $content) {
    success
    code
    message
  }
}
    `
export const GetSigningUrlExternalDocument = `
    query getSigningUrlExternal($input: GetSigningUrlExternalInput!) {
  getSigningUrlExternal(input: $input) {
    code
    message
    signingUrl
    shouldEmbed
  }
}
    `

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createFormSubmission: build.mutation<
      Types.CreateFormSubmission,
      Types.CreateFormSubmissionVariables
    >({
      query: (variables) => ({
        document: CreateFormSubmissionDocument,
        variables,
      }),
    }),
    updateFormSubmission: build.mutation<
      Types.UpdateFormSubmission,
      Types.UpdateFormSubmissionVariables
    >({
      query: (variables) => ({
        document: UpdateFormSubmissionDocument,
        variables,
      }),
    }),
    completeFormSubmission: build.mutation<
      Types.CompleteFormSubmission,
      Types.CompleteFormSubmissionVariables
    >({
      query: (variables) => ({
        document: CompleteFormSubmissionDocument,
        variables,
      }),
    }),
    createConsentPacketExternal: build.mutation<
      Types.CreateConsentPacketExternal,
      Types.CreateConsentPacketExternalVariables
    >({
      query: (variables) => ({
        document: CreateConsentPacketExternalDocument,
        variables,
      }),
    }),
    getSigningUrlExternal: build.query<
      Types.GetSigningUrlExternal,
      Types.GetSigningUrlExternalVariables
    >({
      query: (variables) => ({
        document: GetSigningUrlExternalDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
